import React, { useEffect, useState } from 'react';
import { Divider, Grid, makeStyles, Popover, Typography, useTheme } from '@quillbot/design-system';
import Img from '@Common/components/img';

const useStyles = makeStyles(() => ({
  popoverContent: {
    pointerEvents: 'auto',
  },
  text: {
    fontWeight: 600,
    fontSize: '13px',
    lineHeight: '18px',
  },
}));

const LanguageMenu = ({
  open,
  setLanguageMenuOpen,
  handleLanguageChange,
  LANGUAGES,
  anchorElement,
}: {
  open: boolean;
  setLanguageMenuOpen: Function;
  handleLanguageChange: Function;
  LANGUAGES: any;
  anchorElement?: Element | null;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setAnchorEl(document.getElementById('language-menu-button') as HTMLElement);
  }, []);

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Popover
      sx={{
        pointerEvents: 'none',
      }}
      classes={{
        paper: classes.popoverContent,
      }}
      open={open}
      anchorEl={anchorElement || anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableRestoreFocus
      PaperProps={{
        onMouseEnter: () => setLanguageMenuOpen(true),
        onMouseLeave: () => setLanguageMenuOpen(false),
      }}>
      <Grid
        container
        flexDirection="column"
        sx={{
          width: 240,
          border: `1px solid ${theme.palette.divider}`,
          boxSizing: 'border-box',
          boxShadow: theme.shadows[5],
          borderRadius: '8px',
          overflow: 'hidden',
        }}>
        <Grid item sx={{ padding: '11px 16px' }}>
          <Typography className={classes.text}>I write in</Typography>
        </Grid>
        <Divider />
        {Object.keys(LANGUAGES).map((language) => (
          <span key={language}>
            <Grid
              item
              sx={{
                display: 'flex',
                padding: '11px 16px',
                alignItems: 'center',
                cursor: 'pointer',
                ':hover': { background: theme.palette.background.default },
              }}
              onClick={() => handleLanguageChange(language)}
              key={language}>
              <Img
                src={LANGUAGES[language].imagePath}
                alt="language menu"
                style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  marginRight: 10,
                }}
              />
              <Typography className={classes.text}>{LANGUAGES[language].displayText}</Typography>
            </Grid>
            <Divider />
          </span>
        ))}
      </Grid>
    </Popover>
  );
};

export default LanguageMenu;
